import React, { Component } from 'react';
import DOMPurify from 'dompurify';
//import '.././App.css';
import GlobalStoreService from '../../services/global-store.service'
import PlatformType from '../../enums/PlatformType';
import ConfirmationBox from '../common-components/confirmation-box.component'
import UtilService from "../../services/util.service";
import UserActionClass from '../../objectClasses/user-action-class'
import UserActionType from '../../enums/UserActionType'

const CommonOptionsResponseComponent = ({chatItem ={},handleUserAction,showFeedbackOptions,show_retry,onRetryClick,showPopup}) => {

    let{response,options,type,sentTime,scenarioObject,scenarioActive,scenarioResponse} = chatItem;
    
    return(
        <div id="options_bar_position_id" style={{width:'100%'}}>
            {show_retry &&
                <div className="btm-links2">
                    <ul id="options_scroll_bar" style={(GlobalStoreService.get('platformType')===PlatformType.WEB) ? {flexWrap:'wrap',justifyContent:'center',width:(UtilService.getOS() === "Windows")?'calc(100vw - 20px)':'100vw'} : {}}>
                        <li><a onClick={()=>{
                            // onRetryClick()
                            handleUserAction(new UserActionClass(UserActionType.RETRY_CLICK))
                            }}>
                        Retry</a></li>
                    </ul>
                </div>
        }
            { !show_retry &&  !showFeedbackOptions && options &&
            <div  className="btm-links2">
                <ul id="options_scroll_bar" style={
                    ( GlobalStoreService.get('platformType')===PlatformType.WEB) ? {flexWrap:'wrap',justifyContent:'center',width:(UtilService.getOS() === "Windows")?'calc(100vw - 20px)':'100vw'} : {}}>
                    {options.map((option,index)=>{
                        return (<li 
                            // style={(GlobalStoreService.get('platformType')!==PlatformType.WEB && index===0)?{paddingLeft:'51px'}:{}}
                            className="choice_list_item" key = {index}><a href="javascript:void(0)" onClick={()=>{
                            if(scenarioResponse && scenarioResponse.templateNameList && 
                                scenarioResponse.templateNameList.includes('IR_149_SERVICE_PROV') && option.displayText==='Yes'){
                                    showPopup(
                                        <ConfirmationBox
                                            title={'IR Service Activation'}
                                            messages={['By subscribing this service, you will incur a charge of Rs. 149. Are you sure you want to proceed?']}
                                            buttons={[
                                                {
                                                    label: 'NO',
                                                    onClick: () => {
                                                        showPopup(undefined)
                                                        handleUserAction(new UserActionClass(UserActionType.CHOICE_CLICKED,'No'))
                                                    }
                                                },
                                                {   highlight:true,
                                                    label: 'YES',
                                                    onClick: () => {
                                                        showPopup(undefined)
                                                        handleUserAction(new UserActionClass(UserActionType.CHOICE_CLICKED,'Yes'))
                                                    }
                                                }
                                            ]}/>)
                            }
                            else{
                                handleUserAction(new UserActionClass(UserActionType.CHOICE_CLICKED,option.displayText))
                            }
                        }}>{option.displayText}</a></li> )}
                    )}
                </ul>
            </div>}
            {!show_retry && (showFeedbackOptions) &&
            <div className="rate text-center" style={{padding:'10px 0'}}>
                <ul>
                    <li><a id="feedback-up" shref="javascript:void(0)" className="up"
                           onClick={()=>{
                            handleUserAction(new UserActionClass(UserActionType.FEEDBACK_CLICK,'GOOD_FEEDBACK'))
                           }}
                        ><img src={`${process.env.PUBLIC_URL}/assets/images/like.svg`} width="20"/></a></li>
                    <li><a id="feedback-down" href="javascript:void(0)" className="response-down text-center"
                           onClick={()=>{
                                handleUserAction(new UserActionClass(UserActionType.FEEDBACK_CLICK,'BAD_FEEDBACK'))
                           }}
                        ><img src={`${process.env.PUBLIC_URL}/assets/images/like.svg`} width="20"/></a></li>
                </ul>
                <p className="color-grey fs-10">How would you rate this solution?</p>
            </div>}
        </div>

    )
}

export default CommonOptionsResponseComponent



// WEBPACK FOOTER //
// ./src/components/scenario-options-components/options-response.component.js